import React, {Component} from 'react';

export default class Topbar extends Component{

    componentDidMount(){

        window.mobile_menu_initialized = false;
        window.toggle_initialized = false;
        window.bootstrap_nav_initialized = false;
        window.pdp.initSidebarMenu();
    }

    render(){

        const route = this.props.route;

        return(

            <nav className="navbar navbar-default">
                <div className="container-fluid">
                    <div className="navbar-minimize">
                        <button id="minimizeSidebar" className="btn btn-fill btn-icon"><i className="ti-more-alt" /></button>
                    </div>
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle">
                            <span className="sr-only">Toggle navigation</span>
                            <span className="icon-bar bar1" />
                            <span className="icon-bar bar2" />
                            <span className="icon-bar bar3" />
                        </button>

                        <a className="navbar-brand">{route.name}</a>

                    </div>

                    <div className="collapse navbar-collapse">

                        {route.searchable?
                            <form className="navbar-form navbar-left navbar-search-form" role="search">
                                <div className="input-group">
                                    <span className="input-group-addon"><i className="fa fa-search"/></span>
                                    <input type="text" className="form-control" placeholder="Search..." />
                                </div>
                            </form>
                            :null}

                        {/*
                        <ul className="nav navbar-nav navbar-right">

                            <li className="dropdown">
                                <a href="#notifications" className="dropdown-toggle btn-rotate" data-toggle="dropdown">
                                    <i className="ti-bell" />{" "}
                                    <span className="notification">5</span>
                                    <p className="hidden-md hidden-lg">
                                        Notifications
                                        <b className="caret" />
                                    </p>
                                </a>
                                <ul className="dropdown-menu">
                                    <li><a href="#not1">Notification 1</a></li>
                                    <li><a href="#not2">Notification 2</a></li>
                                    <li><a href="#not3">Notification 3</a></li>
                                    <li><a href="#not4">Notification 4</a></li>
                                    <li><a href="#another">Another notification</a></li>
                                </ul>
                            </li>

                        </ul>
                        */}
                    </div>
                </div>
            </nav>
        );
    }
}




// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/components/Topbar/index.jsx